export default __webpack_public_path__ + "static/media/tachy_work2.800824cd.jpg";